import React from 'react';

import './vs.scss';

interface Props {
    symbol?: '+' | '=';
}

export default function VS(props: Props) {
    const { symbol } = props;

    return (
        <div styleName="container" className="__app-VS-container">
            {symbol || 'vs'}
        </div>
    );
}
